import PlaybackRateMenu from './PlaybackRateMenu';

export default PlaybackRateMenu;
